import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NbMenuModule, NbButtonModule, NbIconModule } from '@nebular/theme';

import { AuthGuard } from '../auth-guard.service';
import { PageComponent } from './page.component';
import { ThemeModule } from '../@theme/theme.module';
import { MenuService } from './menu.service';

const NB_MODULES = [
  NbMenuModule,
  NbButtonModule,
  NbIconModule
];
const PAGES_COMPONENTS = [
  PageComponent,
];

const routes: Routes = [{
  canActivate: [AuthGuard],
  path: '',
  component: PageComponent,
  children: [

    {
      path: '', loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
      path: 'dashboard', loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
      path: 'documents', loadChildren: () => import('../documents/documents.module').then(m => m.DocumentsModule)
    },
    {
      path: 'templates', loadChildren: () => import('../templates/templates.module').then(m => m.TemplatesModule)
    },
    {
      path: 'moreinfo', loadChildren: () => import('../@addins/system/system-addin.module').then(m => m.SystemAddinModule)
    },
    
  ],
}
];

@NgModule({
  imports: [
    ThemeModule,
    [RouterModule.forChild(routes)],
    ...NB_MODULES
  ],
  declarations: [
    ...PAGES_COMPONENTS,
  ],
  exports: [RouterModule],
})
export class PagesModule {
}
